import { useQuery } from "react-query";

import { getAccidentResponsibility } from "api/getAccidentResponsibility";

export const useGetAccidentResponsibility = (
  phVehicleCircumstance: string | null = null,
  otherVehicleCircumstance: string | null = null
) => {
  const { data } = useQuery(
    `getAccidentResponsibility-${phVehicleCircumstance}-${otherVehicleCircumstance}`,
    () => getAccidentResponsibility(phVehicleCircumstance as string, otherVehicleCircumstance as string),
    {
      enabled: !!phVehicleCircumstance && !!otherVehicleCircumstance,
    }
  );

  return data;
};
